<template>
    <v-app-bar
        app
        color="shades black"
        :clipped-left="$vuetify.breakpoint.lgAndUp"
    >
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-app-bar-nav-icon
                    v-show="isNavMenuButtonVisible"
                    dark
                    aria-label="Toggle left navigation menu"
                    style="z-index: 1;"
                    v-on="on"
                    @click="toggleNavDrawer"
                ></v-app-bar-nav-icon>
            </template>
            <span>Toggle left navigation bar</span>
        </v-tooltip>
        <div class="branding-image-container">
            <img
                :src="venueIcon"
                :alt="venueName"
                class="branding mx-3"
                height="32px"
                @error="onLogoError"
            />
        </div>
        <v-toolbar-title v-if="isUserAuthenticated" class="ml-1 text-h6">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-show="canSwitchVenue"
                        color="genes-blue"
                        class="text-h6"
                        text
                        v-on="on"
                        @click="onVenueNameClick"
                        ><span>{{ venueName }}</span>
                    </v-btn>
                    <span
                        v-show="venueName && !canSwitchVenue"
                        class="white--text"
                        v-on="on"
                        >{{ venueName }}</span
                    >
                </template>
                <div>
                    <div>Billing ID: {{ venueBillingId }}</div>
                    <div v-show="canSwitchVenue">
                        Click here to switch venue...
                    </div>
                </div>
            </v-tooltip>
        </v-toolbar-title>
        <div
            v-show="!isUserAuthenticated || !venueName"
            class="toolbar-title-row text-h6"
        >
            <v-toolbar-title class="text-h6">
                Venue Management System
            </v-toolbar-title>
        </div>
        <v-spacer></v-spacer>
        <language-select v-if="earlyAccess"></language-select>
        <div id="language-menu"></div>
        <app-header-speed-dial></app-header-speed-dial>
    </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { isEmpty } from '@/common/helpers';
import AppHeaderSpeedDial from './AppHeaderSpeedDial';
import LanguageSelect from './LanguageSelect';

export default {
    name: 'AppHeader',
    components: {
        'app-header-speed-dial': AppHeaderSpeedDial,
        'language-select': LanguageSelect
    },
    computed: {
        ...mapState('venue', ['selectedVenue', 'selectedVenueInfo']),
        ...mapGetters('authUser', [
            'isUserAuthenticated',
            'isUserMemberOfMultipleVenues'
        ]),
        ...mapGetters('venue', ['venueBillingId']),
        ...mapState(['navDrawer', 'earlyAccess']),
        ...mapGetters('brand', ['currentMsoLogo']),
        userFullName() {
            if (!isEmpty(this.userInfo)) {
                return `${this.userInfo.firstName} ${this.userInfo.lastName}`;
            }
            return '';
        },
        isNavMenuButtonVisible() {
            return this.isUserAuthenticated;
        },
        venueIcon() {
            if (
                !isEmpty(this.selectedVenueInfo) &&
                this.selectedVenueInfo.icon
            ) {
                return `/assets/images/logos/hotels/${this.selectedVenueInfo.icon}`;
            }
            return this.currentMsoLogo;
        },
        venueName() {
            if (this.selectedVenueInfo && this.selectedVenueInfo.id) {
                const title =
                    this.selectedVenueInfo.title || this.selectedVenueInfo.name;
                return title;
            }
            return '';
        },
        canSwitchVenue() {
            return this.venueName.length && this.isUserMemberOfMultipleVenues;
        }
    },
    methods: {
        ...mapMutations(['setNavDrawer']),
        // ========================= Events =======================
        onVenueNameClick() {
            if (this.$router.currentRoute.name !== 'venueSwitcherPage') {
                this.$router.push({ name: 'venueSwitcherPage' });
            }
        },
        toggleNavDrawer() {
            this.setNavDrawer(!this.navDrawer);
        },
        onLogoError(e) {
            e.target.src = this.currentMsoLogo;
        }
    }
};
</script>

<style lang="scss">
.toolbar-title-row {
    position: absolute;
    width: 100%;
    text-align: center;
    color: #ffffff;
}
.branding-image-container {
    min-width: 180px;
}
img.branding {
    vertical-align: middle;
}
</style>
